import {
  AfterContentInit,
  AfterViewChecked, AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {DefaultSettingsService, ExcCurrency} from '../default-settings-service.service';
import {ExcRestService} from 'exc-rest';
import {ExcListComponent, ExcListConfig, ExcTableConfig, OverlayConfig, OverlayService} from 'exc-controls';
import Viewer from 'viewerjs';
import {ExcTab, IExcTab} from 'exc-tab';
import {AuditDetailsComponent} from '../audit-details/audit-details.component';
import {ModalCommentComponent} from '../modals/modal-comment/modal-comment.component';
import {AttachmentViewerComponent} from '../attachment-viewer/attachment-viewer.component';
import {ExcFilter, ExcSort, FilterSortService, ExcFilterCondition} from '../filter-sort-service.service';
import {ModalReviewBatchEditComponent} from '../modals/modal-review-batch-edit/modal-review-batch-edit.component';
import {forkJoin, Observable} from 'rxjs';
import {ModalReviewFinsihComponent} from '../modals/modal-review-finsih/modal-review-finsih.component';
import {ModalYesNoComponent} from '../modals/modal-yes-no/modal-yes-no.component';
import {AuditActionResult, AuditActionService} from '../audit-action-service.service';
import {_def} from '@angular/core/src/view/provider';
import {ExcSigninService} from 'exc-signin';
import {ModalFollowupDateEditComponent} from '../modals/modal-followup-date-edit/modal-followup-date-edit.component';
import {ReviewActionService} from '../review-action-service';
import {ModalReviewGroupAddComponent} from '../modals/modal-review-group-add/modal-review-group-add.component';
import {ModalReviewGroupEditDescriptionComponent} from '../modals/modal-review-group-edit-description/modal-review-group-edit-description.component';
import {ExcUploadDialogComponent} from '../attachments/exc-upload-dialog/exc-upload-dialog.component';
import {ExcUploadDirective} from '../attachments/directives/exc-upload.directive';
import {ExcFileItem} from '../attachments/models/ExcFileItem';
import {ModalAuditPinChangedComponent} from '../modals/modal-audit-pin-changed/modal-audit-pin-changed.component';
import {
  ModalDealerBlackWhiteListComponent
} from '../modals/modal-dealer-black-white-list/modal-dealer-black-white-list.component';

@Component({
  selector: 'app-audit-review',
  templateUrl: './audit-review.component.html',
  styles: [],
  providers: [ExcCurrency]
})
export class AuditReviewComponent extends ExcTranslation implements OnInit, AfterViewChecked, IExcTab, AfterContentInit, AfterViewInit {
  tabinstance: any;
  @ViewChild('invFilter') invFilter;
  @ViewChild('mapInstance') mapContainer: any;
  @ViewChild('imageHost') imageHost;
  @ViewChild('vidHost') vidHost;
  @ViewChild('menuPopup') menuPopup;
  @ViewChild('itemAttUpload', {read: ExcUploadDirective}) excUpload: ExcUploadDirective;
  @ViewChild(AttachmentViewerComponent) attachmentViewer;
  @ViewChild('inventoryList') inventoryList: ExcListComponent;
  @ViewChild('incomingData') incomingData: any[] = [];

  viewer: Viewer = null;
  Data: any;
  inventoryListConfig: ExcListConfig = new ExcListConfig();
  commentsListConfig: ExcListConfig = new ExcListConfig();
  backcheckConfig: ExcTableConfig = new ExcTableConfig();
  mapData = {DealerMarker: null, DealerCircle: null, InventoryMarker: null, InventoryCircle: null, LinkedDealerMarkers: [], LinkedDealerCircles: [], LinkedInventoryMarkers: [], LinkedInventoryCircles: [], AdditionalMarkers: []};
  filters = {onlyOpen: false, ocrFail: false};
  searchValues = {Inventory: '', Comments: '', Attachments: '', Audit: ''};
  selected = {Inventory: null, Comment: null, Location: null, Image: null};
  validation: {ValidatedBy: string, ValidatedDate: any, ValidatedOk: boolean, ValidationComment: string, ValidationTarget: string, Data: {id: number, ok: boolean, pos: string, neg: string}[]}[] = [];
  data = {Inventory: [], Comments: [], Review: {}, Locations: [], Codes: [], Filters: [], Header: {IsGroup: false} as any, Dealer: [] as any[], DealerLevels: [], GroupAudits: [], Auditors: []};
  item: {OriginalData: [], Backcheck: [], Attachments: []} = {Attachments: [], Backcheck: [], OriginalData: []};
  imageSelectionChanged = false;
  resultOptions = [];
  current: {InventoryClearedCode: number, InventoryClearedComment: string} = {InventoryClearedCode: null, InventoryClearedComment: null};
  mapContentChanged = false;
  attachmentHint = {Ok: 0, NOk: 0, Checked: 0, Total: 0};
  isAttachmentLoading = false;
  selectedInventory = [];
  isLoading = true;
  auditlistconfig: ExcListConfig = new ExcListConfig();
  selectedAudits: any[] = [];
  excUploadDirective: ExcUploadDirective = null;
  uploadFormComponent: ExcUploadDialogComponent = null;
  backcheckVinValue = null;
  invFilters: ExcFilter[] = [
    // Auswertung
    // new ExcFilter(1, 'Status', 'InventoryIsCleared', new ExcFilterCondition('=', false), 'fltOpen', 'Globals.onlyOpen', false )
    new ExcFilter(1, this.getGlobal('Review'), 'InventoryClearedStatus', new ExcFilterCondition('=', 1), 'fltReviewOpen', 'Globals.CheckedOpen', false),
    new ExcFilter(1, this.getGlobal('Review'), 'InventoryClearedStatus', new ExcFilterCondition('=', 2), 'fltReviewOk', 'Globals.CheckedOk', false ),
    new ExcFilter(1, this.getGlobal('Review'), 'InventoryClearedStatus', new ExcFilterCondition('=', 3), 'fltReviewNotOk', 'Globals.CheckedNotOk', false),
    new ExcFilter(1, this.getGlobal('Review'), 'InventoryClearedStatus', new ExcFilterCondition('=', 4), 'fltReviewCritical', 'Globals.CheckedCritical', false),
    /*
        // Auswertungsergebnis
        // new ExcFilter(1, this.getGlobal('ClearedCode'), 'InventoryClearedCode', new ExcFilterCondition('=', null), 'fltClearedCodeDbNull', 'Globals.ClearedCodeDbNull', false),
        new ExcFilter(1, this.getGlobal('ClearedCode'), 'InventoryClearedCode', new ExcFilterCondition('=', 1), 'fltClearedCodeOk', 'Globals.ClearedCodeOk', false),
        new ExcFilter(1, this.getGlobal('ClearedCode'), 'InventoryClearedCode', new ExcFilterCondition('=', 2), 'fltClearedCodeInProgress', 'Globals.ClearedCodeInProgress', false),
        new ExcFilter(1, this.getGlobal('ClearedCode'), 'InventoryClearedCode', new ExcFilterCondition('=', 3), 'fltClearedCodeSOT', 'Globals.ClearedCodeSOT', false),
    */
    new ExcFilter(2, '', 'InventoryVIN', new ExcFilterCondition('like', ''), 'fltSearchVin', 'Globals.VIN', false),
    new ExcFilter(2, '', 'InventoryCreditType', new ExcFilterCondition('like', ''), 'fltSearchCreditType', 'Globals.CreditType', false)
  ];

  invSort: ExcSort[] = [new ExcSort('InventoryVIN', 0, 'VIN', 1)
    , new ExcSort('InventoryCreditType', 0, 'CreditType', 0)
    , new ExcSort('InventoryCreditValue', 0, 'CreditValue', 0)];

  constructor(private excDss: DefaultSettingsService, private excRest: ExcRestService, private changeDetectorRef: ChangeDetectorRef,
              private excFss: FilterSortService, private aas: AuditActionService, private excSec: ExcSigninService,
              private excRas: ReviewActionService
  ) {
    super();
    const _self = this;
    _self.auditlistconfig.selectionMode = 'multi';
    _self.auditlistconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.auditlistconfig.OnSearch = function (searchValue, event?) {
      _self.searchValues.Audit = searchValue || '';
      _self.reloadGroupAudits();
    };
    _self.auditlistconfig.OnPageChanged = (pageNo, event1) => {
      _self.auditlistconfig.paging.pagingPage = pageNo;
      _self.reloadGroupAudits();
    };
    _self.auditlistconfig.OnRefresh = () => {
      _self.reloadGroupAudits();
    };
    _self.auditlistconfig.OnSelectionChanged = (selectedItems, event1) => {
      _self.selectedAudits = selectedItems;
    };
    _self.auditlistconfig.OnDetailLink = (item) => {
      new ExcTab(item['DealerName'] + ' - ' + item.AuditID, AuditDetailsComponent, item, item.AuditID, {
        Unique: true, ReloadParent: function () {
          _self.reloadAudits();
        }
      }, true).Open();
    };
    _self.inventoryListConfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.inventoryListConfig.selectionMode = 'multi';
    _self.inventoryListConfig.selectionKey = 'InventoryID';
    _self.inventoryListConfig.selectFirstAfterInit = true;
    _self.inventoryListConfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.inventoryListConfig.OnFilterClick = (event) => {
      _self.invFilter.show(event);
    };
    _self.inventoryListConfig.OnFilter = () => {
    };
    _self.inventoryListConfig.OnSearch = function (searchValue, event?) {
      _self.searchValues.Inventory = searchValue || '';
      _self.reloadInventory();
    };
    _self.inventoryListConfig.OnPageChanged = (pageNo, event1) => {
      _self.inventoryListConfig.paging.pagingPage = pageNo;
      _self.reloadInventory();
    };
    _self.inventoryListConfig.OnRefresh = () => {
      // _self.selected.Inventory = null;

      _self.reloadInventory();
    };
    _self.inventoryListConfig.OnFocus = (focusItem) => {
      if (focusItem !== null) {
        _self.current.InventoryClearedCode = focusItem.InventoryClearedCode;
        _self.current.InventoryClearedComment = focusItem.InventoryClearedComment;
        let isDifferent = false;
        if (_self.selected.Inventory !== null && focusItem !== null && _self.selected.Inventory.InventoryID === focusItem.InventoryID) {
          isDifferent = true;
        }
        _self.selected.Inventory = focusItem;
        for (const x of _self.data.Locations) {
          if (x['LocationKey'] === _self.selected.Inventory['InventoryLocation'] && x['LocationAudit'] === _self.selected.Inventory['AuditID']) {
            this.selected.Location = x;
            break;
          }
        }
        if (isDifferent === false) {
        _self.loadItem();
        }
      } else {
        _self.selected.Inventory = null;
      }
    };
    _self.inventoryListConfig.OnSelectionChanged = (selectedItems) => {
      this.selectedInventory = selectedItems;
      this.mapContentChanged = true;
    };
    _self.backcheckConfig.OnSelectionChanged = (selectedItem) => {
      console.log(selectedItem);
    };
    _self.commentsListConfig.selectionMode = 'single';
    _self.commentsListConfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.commentsListConfig.OnSearch = function (searchValue, event?) {
      _self.searchValues.Comments = searchValue || '';
      _self.reloadComments();
    };
    _self.commentsListConfig.OnPageChanged = (pageNo, event1) => {
      _self.commentsListConfig.paging.pagingPage = pageNo;
      _self.reloadComments();
    };
    _self.commentsListConfig.OnRefresh = () => {
      _self.reloadComments();
    };
    _self.commentsListConfig.OnSelectionChanged = (selectedItems) => {
      _self.selected.Comment = selectedItems[0] || null;
    };
  }
  ngOnInit() {
    this.initialLoad();
  }
  ngAfterViewChecked() {
    if (this.mapContentChanged === true) {
      this.redrawMap();
      this.mapContentChanged = false;
    }
  }
  ngAfterContentInit() {
  }

  ngAfterViewInit() {
    if (this.Data.VehicleVIN) {
      setTimeout(() => {
        this.inventoryListConfig.OnSearch(this.Data.VehicleVIN);
        this.inventoryList.searchValue = this.Data.VehicleVIN;
      }, 500);
    }
  }

  // async onAddUpload(uploads: ExcFileItem[]) {
  //   this.excUploadDirective.startLoadingAnimation();
  //   const url = this.excRest.computeUrl('AuditReviewItemAttachmentC', {FKID: this.ID});
  //   const formData = this.createFormData(uploads);
  //   this.excRest.post(url, formData, {})
  //     .subscribe(() => {
  //       this.reloadAttachments();
  //       this.excUploadDirective.close();
  //     });
  // }
  reloadAttachments() {
    const _self = this;
    const url = this.excRest.computeUrl(
      'AuditReviewAttachmentR_List', {FKID: this.selected.Inventory.InventoryID}
    );
    this.excRest.sget(url, 'LEALIST', {})
      .subscribe(data => {
        _self.item.Attachments = data.response.data;
      });
  }
  reloadObjectAttachments() {
    const _self = this;
    const url = this.excRest.computeUrl(
      'AuditReviewItemAttachmentR_List', {FKID: this.selected.Inventory.InventoryID}
    );
    this.excRest.sget(url, 'LEALIST', {})
      .subscribe(data => {
        _self.item.Attachments = data.response.data;
      });
  }
  getObjectAttachmentIconClass(att) {
    const cls = [];
    if (att.AttachmentMIME.startsWith('image/')) {
      cls.push('fa-image');

    } else if (att.AttachmentMIME.startsWith('video/')) {
      cls.push('fa-video');

    } else if (att.AttachmentMIME === 'application/pdf') {
      cls.push('fa-file-pdf');

    } else {
      cls.push('fa-file');
    }
    if (att.AttachmentCleared === true) {
      if (att.AttachmentClearedOk === true) {
        cls.push('th-success');
      } else {
        cls.push('th-danger');
      }
    } else {
      cls.push('th-warning');
    }
    return cls;
  }
  deleteObjectAttachment(att) {
    const _self = this;
    ExcCoreModule.showModal(ModalYesNoComponent, null, 'xs', {Message: _self.getGlobal('DeleteObjectAttachment')}, false).subscribe( r => {
      if (r && r.proceed === true) {
        const url = _self.excRest.computeUrl('AuditReviewItemAttachmentD', {InventoryID: _self.selected.Inventory.InventoryID, AttachmentID: att.AttachmentID});
        _self.excRest.delete(url, {}, {}).subscribe(response => {
          _self.item.Attachments = response.data;
        });
      }
    });
  }

  addAttachmentToObject(fileData) {
    const _self = this;
    const formData = new FormData();
    Object.keys(fileData[0].misc).forEach(key => {
      formData.append(key, fileData[0].misc[key]);
    });
    // -- consider file data
    fileData.forEach(upload => formData.append('file[]', upload.asBlob, upload.fullName));
    _self.excRest.put(_self.excRest.computeUrl('AuditReviewItemAttachmentC', {InventoryID: _self.selected.Inventory.InventoryID}),
      formData, {})
      .subscribe(response => {
        _self.excUpload.close();
        _self.reloadObjectAttachments();
      });
  }
  reloadGroupAudits() {
    const _self = this;

    const url = _self.excRest.computeUrl('ReviewGroupR_List', {AuditGroup: this.data.Header['AuditGroup']});
    _self.auditlistconfig.isLoading = true;
    const mi = _self.auditlistconfig.GetMetaInfo();
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(r => {
      if (r && r.success === true) {
        _self.data.GroupAudits = r.data;
        _self.auditlistconfig.paging = r.paging;
      } else {
        _self.data.GroupAudits = [];
      }
      _self.auditlistconfig.isLoading = false;
    });
  }
  editAuditGroupDescription() {
    const _self = this;
    ExcCoreModule.showModal(ModalReviewGroupEditDescriptionComponent, null, 'xl', {PossibleAudits: _self.data.GroupAudits, Header: this.data.Header}, false).subscribe(res => {
      if (res && res.proceed === true) {
        const url = _self.excRest.computeUrl('ReviewGroupU_Edit', {AuditGroup: this.data.Header['AuditGroup']});
        _self.auditlistconfig.isLoading = true;
        _self.excRest.post(url, {AuditID: res.AuditLead, GroupHeader: res.GroupHeader, GroupBody: res.GroupBody}, {}).subscribe(r => {
          if (r && r.success === true) {
            Object.assign(_self.data.Header, r.data[0]);
            _self.auditlistconfig.paging = r.paging;
            _self.tabinstance.Config.ReloadParent();
          }
          _self.auditlistconfig.isLoading = false;
        });
      }
    });
  }
  addAuditsToGroup() {
    const _self = this;
    ExcCoreModule.showModal(ModalReviewGroupAddComponent, null, 'xl', {Audits: _self.data.GroupAudits}, false).subscribe(res => {
      if (res && res.proceed === true) {
        const url = _self.excRest.computeUrl('ReviewGroupU_AuditAdd', {AuditGroup: this.data.Header['AuditGroup']});
        _self.auditlistconfig.isLoading = true;
        let audits = '';
        for (let i = 0; i < res.Audits.length; i++) {
          audits = audits + (i === 0 ? '' : '|') + res.Audits[i]['AuditID'];
        }
        _self.excRest.post(url, {Audits: audits}, {}).subscribe(r => {
          if (r && r.success === true) {
            _self.data.GroupAudits = r.data;
            _self.auditlistconfig.paging = r.paging;
            _self.initialLoad();
            _self.tabinstance.Config.ReloadParent();

          }
          _self.auditlistconfig.isLoading = false;
        });
      }
    });
  }
  removeAuditsFromGroup() {
    const _self = this;
    const url = _self.excRest.computeUrl('ReviewGroupU_AuditDel', {AuditGroup: this.data.Header['AuditGroup']});
    _self.auditlistconfig.isLoading = true;
    let audits = '';
    for (let i = 0; i < _self.selectedAudits.length; i++) {
      audits = audits + (i === 0 ? '' : '|') + _self.selectedAudits[i]['AuditID'];
    }
    _self.excRest.post(url, {Audits: audits}, {}).subscribe(r => {
      if (r && r.success === true) {
        _self.data.GroupAudits = r.data;
        _self.auditlistconfig.paging = r.paging;
        _self.initialLoad();
        _self.tabinstance.Config.ReloadParent();

      }
      _self.auditlistconfig.isLoading = false;
      _self.selectedAudits = [];
    });
  }

  verifyImage(isOk: boolean) {
    const _self = this;
    const url = this.excRest.computeUrl('ReviewAttachmentU_Clear', {AuditID: this.Data.AuditID, InventoryID: this.selected.Inventory.InventoryID, AttachmentID: this.selected.Image.AttachmentID});
    if (isOk === false) {
      ExcCoreModule.showModal(ModalCommentComponent, null, 'm', {Header: this.getRessource('HeaderNotOkVerification'), Comment: this.selected.Image.AttachmentComment || ''}, false, null).subscribe( ret => {
        if (ret && ret.proceed === true) {
          _self.excRest.post(url, {IsOk: isOk, Comment: ret.Comment}, {}).subscribe(verified => {
            if (verified) {
              // setTimeout(() => {
              Object.assign(this.selected.Image, verified.data[0]);
              for (let a = 0; a < this.data.Inventory.length; a++) {
                if (this.data.Inventory[a].InventoryID === this.selected.Inventory.InventoryID) {
                  if (this.data.Inventory[a].Results && this.data.Inventory[a].Results.length > 0) {
                    for (let i = 0; i < this.data.Inventory[a].Results.length; i++) {
                      if (this.data.Inventory[a].Results[i].SubInventoryID === verified.data[0].InventoryID) {
                        this.data.Inventory[a].Results[i].InventoryAttachmentsAllCleared = verified.data[0].InventoryAttachmentsAllCleared;
                        this.data.Inventory[a].Results[i].InventoryAttachmentsAllOk = verified.data[0].InventoryAttachmentsAllOk;
                      }
                    }
                  } else {
                    this.selected.Inventory.InventoryAttachmentsAllCleared = verified.data[0].InventoryAttachmentsAllCleared;
                    this.selected.Inventory.InventoryAttachmentsAllOk = verified.data[0].InventoryAttachmentsAllOk;
                  }
                }
              }
              // }, 100);
            }
          });
        }
      });
    } else {
      _self.excRest.post(url, {IsOk: isOk, Comment: null}, {}).subscribe(verified => {
        if (verified) {
          // setTimeout(() => {
          Object.assign(this.selected.Image, verified.data[0]);
          for (let a = 0; a < this.data.Inventory.length; a++) {
            if (this.data.Inventory[a].InventoryID === this.selected.Inventory.InventoryID) {
              if (this.data.Inventory[a].Results && this.data.Inventory[a].Results.length > 0) {
                for (let i = 0; i < this.data.Inventory[a].Results.length; i++) {
                  if (this.data.Inventory[a].Results[i].SubInventoryID === verified.data[0].InventoryID) {
                    this.data.Inventory[a].Results[i].InventoryAttachmentsAllCleared = verified.data[0].InventoryAttachmentsAllCleared;
                    this.data.Inventory[a].Results[i].InventoryAttachmentsAllOk = verified.data[0].InventoryAttachmentsAllOk;
                  }
                }
              } else {
                this.selected.Inventory.InventoryAttachmentsAllCleared = verified.data[0].InventoryAttachmentsAllCleared;
                this.selected.Inventory.InventoryAttachmentsAllOk = verified.data[0].InventoryAttachmentsAllOk;
              }
            }
          }
          // }, 100);
        }
      });
    }
  }
  verifyAllImages(isOk: boolean) {
    const _self = this;
    const url = this.excRest.computeUrl('ReviewItemImagesU_Clear', {AuditID: this.Data.AuditID, InventoryID: this.selected.Inventory.InventoryID});
    if (isOk === false) {
      ExcCoreModule.showModal(ModalCommentComponent, null, 'm', {Header: this.getRessource('HeaderNotOkVerification'), Comment: this.selected.Image.AttachmentComment || ''}, false, null).subscribe( ret => {
        if (ret && ret.proceed === true) {
          _self.excRest.post(url, {IsOk: isOk, Comment: ret.Comment}, {}).subscribe(verified => {
            if (verified) {
              for (let i = 0; i < verified.data.length; i++) {
                Object.assign(this.item.Attachments[i], verified.data[i]);
              }
            }
          });
        }
      });
    } else {
      _self.excRest.post(url, {IsOk: isOk, Comment: null}, {}).subscribe(verified => {
        if (verified) {
          for (let i = 0; i < verified.data.length; i++) {
            Object.assign(this.item.Attachments[i], verified.data[i]);
          }
        }
      });
    }
  }
  closeAndScoreAudit(e) {

  }
  clearItem() {
    const _self = this;
    const url = this.excRest.computeUrl('AuditReviewItemU_Clear', {AuditID: this.Data.AuditID, InventoryID: this.selected.Inventory.InventoryID});
    this.excRest.post(url, {ClearedCode: this.current.InventoryClearedCode, Comment: this.current.InventoryClearedComment, InventoryUPT: this.selected.Inventory.InventoryUPT}, {}).subscribe(ret => {
      if (ret) {
        Object.assign(_self.selected.Inventory, ret);
      }
    });
  }
  applyFilter() {
    this.invFilter.hide();
    this.reloadInventory();
  }
  resetFilter() {
    this.excFss.ResetFilter(this.invFilters, this.invSort);
    this.invFilter.hide();
    this.reloadInventory();
  }
  setImage(t) {
    this.selected.Image = t;
    this.imageSelectionChanged = true;
    // this.loadImage();
  }
  loadItem() {
    if (this.selected.Inventory === null) {
      return;
    }
    const _self = this;

    let AuditID, InventoryID;

    if (this.selected.Inventory.Results !== undefined && this.selected.Inventory.Results !== null && this.selected.Inventory.Results.length > 0) {
      AuditID = this.selected.Inventory.Results[0].SubAuditID;
      InventoryID = this.selected.Inventory.Results[0].SubInventoryID;
    } else {
      AuditID = this.selected.Inventory.AuditID;
      InventoryID = this.selected.Inventory.InventoryID;
    }
    this.selected.Image = null;
    const url = _self.excRest.computeUrl('AuditReviewItemR_Summary', {AuditID: AuditID, InventoryID: InventoryID, fts: this.searchValues.Inventory == null ? '' : this.searchValues.Inventory});
    const mi = this.inventoryListConfig.GetMetaInfo();
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.item = ret;
        _self.validation = [];
        for (const v of ret.Validation) {
          _self.validation.push({ValidatedBy: v.ValidatedBy, ValidatedDate: v.ValidatedDate, ValidatedOk: v.ValidatedOk, ValidationComment: v.ValidationComment, ValidationTarget: v.ValidationTarget, Data: JSON.parse(v.ValidationError)});
        }
        if (_self.item.Attachments.length > 0) {
          for (let i = 0; i < _self.item.Attachments.length; i++) {
            _self.selected.Image = _self.item.Attachments[i];
            break;
          }
          // this.selected.Image = _self.item.Attachments[0];
          this.imageSelectionChanged = true;
        }
        _self.getAttachmentHint();
        this.mapContentChanged = true;
      }
    });
  }
  gpsDistance(InventoryLatitude, InventoryLongitude, location) {
    if (location === null || InventoryLatitude === null || location.LocationLat === null) {
      return null;
    }
    if ((InventoryLatitude === location.LocationLat)
      && (InventoryLongitude === location.LocationLng)) {
      return 0;
    }

    const R = 6371000;
    const dLat = (location.LocationLat - InventoryLatitude) * (Math.PI / 180);  // deg2rad below
    const dLon = (location.LocationLng - InventoryLongitude) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((InventoryLatitude) * (Math.PI / 180)) * Math.cos(((location.LocationLat) * (Math.PI / 180))) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    return Math.round(d);
  }
  reloadAudits() {
    const _self = this;
    const url = _self.excRest.computeUrl('ReviewAuditR_List', {AuditID: this.Data.AuditID, fts: this.searchValues.Audit == null ? '' : this.searchValues.Audit});
    let mi = this.auditlistconfig.GetMetaInfo();
    mi =  this.excFss.ApplyFilter(mi, this.invFilters, this.invSort);
    _self.auditlistconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.data.GroupAudits = ret.data;
        _self.auditlistconfig.paging = ret.paging;
        _self.auditlistconfig.isLoading = false;
      }
    });
  }
  reloadInventory() {
    const _self = this;
    const url = _self.excRest.computeUrl('AuditReviewInventoryR_List', {AuditID: this.Data.AuditID, fts: this.searchValues.Inventory == null ? '' : this.searchValues.Inventory});
    let mi = this.inventoryListConfig.GetMetaInfo();
    mi =  this.excFss.ApplyFilter(mi, this.invFilters, this.invSort);
    _self.inventoryListConfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.data.Inventory = ret.data.Inventory;
        _self.inventoryListConfig.paging = ret.paging.Inventory;
        for (const x of _self.data.Inventory) {
          if (x.Results && x.Results.length > 0) {
            for (const r of x.Results) {
              let loc = null;
              for (const l of _self.data.Locations) {
                if (l.LocationKey === r.InventoryLocation && r.SubAuditID === l.LocationAudit) {
                  loc = l;
                  break;
                }
              }
              r['InventoryDistance'] = _self.gpsDistance(r.InventoryLatitude, r.InventoryLongitude, loc);
              r['Location'] = loc;
            }
          } else {
            let loc = null;
            let dlr = null;
            for (const l of _self.data.Locations) {
              if (l.LocationKey === x.InventoryLocation && x.AuditID === l.LocationAudit) {
                loc = l;
                break;
              }
            }
            if (_self.data.Header.IsGroup === true) {
              for (const d of _self.data.Dealer) {
                if (d.AuditID === x.AuditID) {
                  dlr = d;
                  break;
                }
              }
            }
            x['InventoryDistance'] = _self.gpsDistance(x.InventoryLatitude, x.InventoryLongitude, loc);
            x['GroupDealer'] = dlr;
          }
        }
        _self.inventoryListConfig.isLoading = false;
      }
    });
  }
  reloadComments() {
    const _self = this;
    const url = _self.excRest.computeUrl('AuditReviewCommentR_List', {AuditID: this.Data.AuditID, fts: this.searchValues.Comments == null ? '' : this.searchValues.Comments});
    const mi = this.commentsListConfig.GetMetaInfo();
    _self.commentsListConfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.data.Comments = ret.data;
        _self.commentsListConfig.paging = ret.paging;
        _self.commentsListConfig.isLoading = false;
      }
    });
  }
  initialLoad() {
    const _self = this;
    const url = this.excRest.computeUrl('AuditReviewR_Summary', {AuditID: this.Data['AuditID']});
    this.inventoryListConfig.isLoading = true;
    this.commentsListConfig.isLoading = true;
    this.auditlistconfig.isLoading = true;
    let mi = this.inventoryListConfig.GetMetaInfo();
    mi =  this.excFss.ApplyFilter(mi, this.invFilters, this.invSort);
    this.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.data.Comments = ret.data.Comments;
        _self.data.Inventory = ret.data.Inventory;
        _self.data.Review = ret.data.Review;
        _self.data.Codes = ret.data.Codes;
        _self.data.Locations = ret.data.Locations;
        _self.data.Filters = ret.data.Filters;
        _self.data.Header = ret.data.Header;
        _self.data.Dealer = ret.data.Dealer;
        _self.data.DealerLevels = ret.data.DealerLevels;
        _self.data.GroupAudits = ret.data.GroupAudits;
        _self.isLoading = false;
        const locCache = [];
        for (const l of _self.data.Locations) {
          // l.fltSet = false;
          let locTitle = '';
          if (l.LocationName === null || l.LocationName === '') {
            locTitle = l.LocationKey + ': ' + l.LocationStreet + ', ' + l.LocationZip + ' ' + l.LocationCity;
          } else {
            locTitle = l.LocationKey + ': ' + l.LocationName + ', ' + l.LocationZip + ' ' + l.LocationCity + ', ' + l.LocationStreet ;
          }
          if (locCache.filter(x => x === locTitle).length === 0) {
            _self.invFilters.push(new ExcFilter(1, 'Globals.Locations', 'LocationID', new ExcFilterCondition('=', l.LocationID), 'flt_' + l.LocationKey, locTitle, false, null, 'right'));
            locCache.push(locTitle);
          }
        }
        _self.invFilters.push(new ExcFilter(1, 'Globals.ApprovedLocationFilter', 'InventoryLocationApproved', new ExcFilterCondition('=', true), 'InventoryLocationApproved', _self.getGlobal('ApprovedLocationFilterOK'), false, null, 'right'));
        _self.invFilters.push(new ExcFilter(1, 'Globals.ApprovedLocationFilter', 'InventoryLocationApproved', new ExcFilterCondition('=', false), 'InventoryLocationApproved', _self.getGlobal('ApprovedLocationFilterNOK'), false, null, 'right'));
        if (_self.data.Header['OcrFailCount'] > 0) {
          _self.invFilters.push(new ExcFilter(1, 'Globals.Selfcheck', 'InventoryHasFallback', new ExcFilterCondition('=', true), 'flt_OcrFailed', _self.getGlobal('OcrFailed'), false, null, 'right'));
        }
        for (const d of _self.data.DealerLevels) {
          this.invFilters.push(    new ExcFilter(1, this.getGlobal('DealersViaLevel'), 'LevelLevel1', new ExcFilterCondition('=', d.DealerLevel1), 'flt_' + d.DealerLevel1, d.DealerLevel1 + ' - ' + d.DealerName + ' ' + d.DealerZip + ' ' + d.DealerCity, false, null, 'right'));
        }
        for (const i of _self.invFilters) {
          i.Container = _self.invFilters;
        }
        for (const x of _self.data.Inventory) {
          if (x.Results && x.Results.length > 0) {
            for (const r of x.Results) {
              let loc = null;
              for (const l of _self.data.Locations) {
                if (l.LocationKey === r.InventoryLocation && r.SubAuditID === l.LocationAudit) {
                  loc = l;
                  break;
                }
              }
              r['InventoryDistance'] = _self.gpsDistance(r.InventoryLatitude, r.InventoryLongitude, loc);
              r['Location'] = loc;
            }
          } else {
            let loc = null;
            let dlr = null;
            for (const l of _self.data.Locations) {
              if (l.LocationKey === x.InventoryLocation && x.AuditID === l.LocationAudit) {
                loc = l;
                break;
              }
            }
            if (_self.data.Header.IsGroup === true) {
              for (const d of _self.data.Dealer) {
                if (d.AuditID === x.AuditID) {
                  dlr = d;
                  break;
                }
              }
            }
            x['InventoryDistance'] = _self.gpsDistance(x.InventoryLatitude, x.InventoryLongitude, loc);
            x['GroupDealer'] = dlr;
          }
        }

        _self.resultOptions = [];
        for (const c of _self.data.Codes) {
          _self.resultOptions.push({text: c.CodeText, value: c.CodeIdent, disabled: false});
          // Filter ReviewResult 12.10.2022
          _self.invFilters.push
          (
            new ExcFilter
            ( 1,
              this.getGlobal('ClearedCode'),
              'InventoryClearedCode',
              new ExcFilterCondition('=', c.CodeIdent),
              'fltr' + c.CodeText,
              c.CodeText,
              false, null, 'right'
            ),
          );
        }

        for (const f of _self.data.Filters) {
          if (f.IsFzg === true) {
            _self.invFilters.push(new ExcFilter(1, this.getGlobal('ObjectResultFrom') + (f && f.SourceAudit !== undefined && f.SourceAudit !== null ? this.getGlobal('AuditType_' + f.SourceAudit) : ''), 'InventoryObjectResult', new ExcFilterCondition('=', f.Flt), 'flt_' + f.Flt, f.Flt + ' - ' + f.Description, false));
          } else {
            _self.invFilters.push(new ExcFilter(1, this.getGlobal('DocumentResultFrom') +  (f && f.SourceAudit !== undefined && f.SourceAudit !== null ? this.getGlobal('AuditType_' + f.SourceAudit) : ''), 'InventoryDocumentResult', new ExcFilterCondition('=', f.Flt), 'flt_' + f.Flt, f.Flt + ' - ' + f.Description, false));
          }
        }
        if (_self.data.Dealer.length > 1) {
          for (const f of _self.data.Dealer) {
            _self.invFilters.push(new ExcFilter(4, 'Globals.Dealer', 'AuditID', new ExcFilterCondition('=', f.AuditID), 'flt_' + f.AuditID, f.DealerLevel1 + ' ' + f.DealerName, false));
          }
        }
        _self.inventoryListConfig.paging = ret.paging.Inventory;
        _self.commentsListConfig.paging = ret.paging.Comments;
        _self.auditlistconfig.paging = ret.paging.GroupAudits;
        _self.auditlistconfig.isLoading = false;
        _self.inventoryListConfig.isLoading = false;
        _self.commentsListConfig.isLoading = false;

        _self.loadItem();
      }
    });
  }
  onTabChange() {
    this.attachmentViewer && this.attachmentViewer.loadItem();
  }
  getAttachmentHint() {
    this.attachmentHint = {Ok: 0, NOk: 0, Checked: 0, Total: 0};
    if (this.item.Attachments.length === 0) {
      return ;
    }

    for (const a of this.item.Attachments) {
      if (a['AttachmentDelayed'] === true) {
        continue;
      }
      if (a['AttachmentCleared'] === true) {
        this.attachmentHint.Checked += 1;
        if (a['AttachmentClearedOk'] === true) {
          this.attachmentHint.Ok += 1;
        } else {
          this.attachmentHint.NOk += 1;
        }
      }
      this.attachmentHint.Total += 1;
    }
  }
  redrawMap() {
    const _self = this;
    if (this.mapContainer === undefined || this.mapContainer.map === undefined) {
      return;
    }
    if (this.selected.Inventory && this.selected.Inventory.Results) {
      this.redrawMapLinked();
    } else {
      this.redrawMapSingle();
    }
  }
  redrawMapLinked() {
    const _self = this;
    if (this.mapContainer === undefined || this.mapContainer.map === undefined) {
      return;
    }
    if (this.mapData.DealerCircle !== null) {
      this.mapData.DealerCircle.setMap(null);
      this.mapData.DealerCircle = null;
    }
    if (this.mapData.DealerMarker !== null) {
      if (_self.selected.Location.LocationID !== this.mapData.DealerMarker['_loc']['LocationID']) {
        this.mapData.DealerMarker.setMap(null);
        this.mapData.DealerMarker = null;
      }
    }
    if (this.mapData.InventoryCircle !== null) {
      this.mapData.InventoryCircle.setMap(null);
      this.mapData.InventoryCircle = null;
    }
    for (const x of this.mapData.LinkedInventoryCircles) {
      x.setMap(null);
    }
    for (const x of this.mapData.LinkedInventoryMarkers) {
      x.setMap(null);
    }
    for (const x of this.mapData.LinkedDealerMarkers) {
      x.setMap(null);
    }
    for (const x of this.mapData.LinkedDealerCircles) {
      x.setMap(null);
    }
    for (const x of this.mapData.AdditionalMarkers) {
      x.setMap(null);
    }
    this.mapData.AdditionalMarkers = [];
    this.mapData.LinkedInventoryMarkers = [];
    this.mapData.LinkedInventoryCircles = [];
    this.mapData.LinkedDealerMarkers = [];
    this.mapData.LinkedDealerCircles = [];
    if (this.mapData.InventoryMarker !== null) {
      this.mapData.InventoryMarker.setMap(null);
      this.mapData.InventoryMarker = null;
    }

    const bounds = new google.maps.LatLngBounds();

    for (const x of _self.selectedInventory) {
      if (x.InventoryID !== _self.selected.Inventory.InventoryID ) {
        for (const rslt of x.Results) {
          if (rslt.InventoryPresent === false || rslt.InventoryLatitude === null || rslt.InventoryLatitude === 0) {
            continue;
          }
          _self.mapData.AdditionalMarkers.push(new google.maps.Marker({position: new google.maps.LatLng(rslt.InventoryLatitude, rslt.InventoryLongitude), map: this.mapContainer.map , icon: { url: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png'}}));
          bounds.extend(new google.maps.LatLng(rslt.InventoryLatitude, rslt.InventoryLongitude));
        }
      }
    }

    for (let i = 0; i < this.selected.Inventory.Results.length; i++) {
      const r = this.selected.Inventory.Results[i];

      if (r.InventoryPresent === false || r.InventoryLatitude === null || r.InventoryLatitude === 0) {
        continue;
      }

      if (r.Location && r.Location.LocationLat !== null && r.Location.LocationLat !== 0) {
        const md = new google.maps.Marker({
          position: new google.maps.LatLng(r.Location.LocationLat, r.Location.LocationLng),
          map: this.mapContainer.map
        });
        // md['_loc'] = location;
        bounds.extend(new google.maps.LatLng(r.Location.LocationLat, r.Location.LocationLng));
        this.mapData.LinkedDealerMarkers.push(md);
      }
      const im = new google.maps.Marker({position: new google.maps.LatLng(r.InventoryLatitude, r.InventoryLongitude), map: this.mapContainer.map , icon: { url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'}});
      let color = '';
      if (r.InventoryAccuracy < 50) {
        color = '#5cb85c';
      } else if (r.InventoryAccuracy >= 50 && r.InventoryAccuracy < 150) {
        color = '#FAA933';
      } else {
        color = '#d9534f';
      }
      this.mapData.LinkedInventoryMarkers.push(im);
      const ic = new google.maps.Circle({center: new google.maps.LatLng(r.InventoryLatitude, r.InventoryLongitude)
        , radius: r.InventoryAccuracy, fillColor: color, fillOpacity: 0.4, strokeOpacity: 0
        , map: this.mapContainer.map
      });
      this.mapData.LinkedInventoryCircles.push(ic);
      bounds.extend(new google.maps.LatLng(r.InventoryLatitude, r.InventoryLongitude));
    }
    this.mapContainer.map.setZoom(25);
    this.mapContainer.map.fitBounds(bounds, 30);
    if (this.mapContainer.map.getZoom() > 18) {
      this.mapContainer.map.setZoom(18);
    }
  }
  redrawMapSingle() {
    const _self = this;
    if (this.mapContainer === undefined || this.mapContainer.map === undefined) {
      return;
    }
    if (this.mapData.DealerCircle !== null) {
      this.mapData.DealerCircle.setMap(null);
      this.mapData.DealerCircle = null;
    }
    if (this.mapData.DealerMarker !== null) {
      if (_self.selected.Location.LocationID !== this.mapData.DealerMarker['_loc']['LocationID']) {
        this.mapData.DealerMarker.setMap(null);
        this.mapData.DealerMarker = null;
      }
    }
    if (this.mapData.InventoryCircle !== null) {
      this.mapData.InventoryCircle.setMap(null);
      this.mapData.InventoryCircle = null;
    }
    if (this.mapData.InventoryMarker !== null) {
      this.mapData.InventoryMarker.setMap(null);
      this.mapData.InventoryMarker = null;
    }

    for (const x of this.mapData.AdditionalMarkers) {
      x.setMap(null);
    }
    _self.mapData.AdditionalMarkers = [];
    const bounds = new google.maps.LatLngBounds();
    for (const x of _self.selectedInventory) {
      if (x.InventoryID !== _self.selected.Inventory.InventoryID) {
        _self.mapData.AdditionalMarkers.push(new google.maps.Marker({position: new google.maps.LatLng(x.InventoryLatitude, x.InventoryLongitude), map: this.mapContainer.map , icon: { url: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png'}}));
        bounds.extend(new google.maps.LatLng(x.InventoryLatitude, x.InventoryLongitude));
      }
    }
    if (this.selected.Inventory.InventoryPresent === false) {
      return;
    }
    if (this.mapData.DealerMarker === null) {
      this.mapData.DealerMarker = new google.maps.Marker({
        position: new google.maps.LatLng(_self.selected.Location.LocationLat, _self.selected.Location.LocationLng),
        map: this.mapContainer.map
      });
      this.mapData.DealerMarker['_loc'] = location;
    }
    this.mapData.InventoryMarker = new google.maps.Marker({position: new google.maps.LatLng(_self.selected.Inventory.InventoryLatitude, _self.selected.Inventory.InventoryLongitude), map: this.mapContainer.map , icon: { url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'}});
    let color = '';
    if (_self.selected.Inventory.InventoryAccuracy < 50) {
      color = '#5cb85c';
    } else if (_self.selected.Inventory.InventoryAccuracy >= 50 && _self.selected.Inventory.InventoryAccuracy < 150) {
      color = '#FAA933';
    } else {
      color = '#d9534f';
    }

    this.mapData.InventoryCircle = new google.maps.Circle({center: new google.maps.LatLng(_self.selected.Inventory.InventoryLatitude, _self.selected.Inventory.InventoryLongitude)
      , radius: _self.selected.Inventory.InventoryAccuracy, fillColor: color, fillOpacity: 0.4, strokeOpacity: 0
      , map: this.mapContainer.map
    });
    bounds.extend(new google.maps.LatLng(_self.selected.Location.LocationLat, _self.selected.Location.LocationLng));
    bounds.extend(new google.maps.LatLng(_self.selected.Inventory.InventoryLatitude, _self.selected.Inventory.InventoryLongitude));
    this.mapContainer.map.setZoom(25);
    this.mapContainer.map.fitBounds(bounds, 30);
    if (this.mapContainer.map.getZoom() > 18) {
      this.mapContainer.map.setZoom(18);
    }
  }
  isLinkedMapAvailable(results) {
    let available = false;
    if (results === null || results.length === 0) {
      return available;
    }
    for (const x of results) {
      if (x.InventoryPresent === true  && x.InventoryLatitude !== null && x.InventoryLatitude !== 0) {
        available = true;
        break;
      }
    }
    return available;
  }
  updateBatch() {
    const _self = this;
    const data = {ElementCount: _self.selectedInventory.length, CodeOptions: _self.resultOptions};
    ExcCoreModule.showModal(ModalReviewBatchEditComponent, null, 'm', data, false, null).subscribe(answer => {
      if (answer && answer.proceed === true) {
        const calls = [];
        for (const inv of _self.selectedInventory) {
          const url = _self.excRest.computeUrl('AuditReviewItemU_Clear', {AuditID: inv.AuditID, InventoryID: inv.InventoryID});
          calls.push(_self.excRest._postInternal(url, {ClearedCode: answer.Code, Comment: `++${answer.Comment || ''}`, InventoryUPT: inv.InventoryUPT}, {}, true));
        }
        forkJoin(calls).subscribe(stack => {
          _self.selectedInventory.forEach((s, idx) => {
            for (const i of _self.data.Inventory) {
              if (s.InventoryID === i.InventoryID) {
                Object.assign(i, stack[idx].data); // <--- statt stack[0]
              }
            }
          });
        });

        /*forkJoin(calls).subscribe(stack => {
          for (const s of _self.selectedInventory) {
            for (const i of _self.data.Inventory) {
              if (s.InventoryID === i.InventoryID) {
                Object.assign(i, stack[0].data);
              }
            }
          }
          // for (let i = 0; i < stack.length; i++) {
          //   for (const o of _self.data.Inventory) {
          //     if (o.Results !== undefined) {
          //      for (const r of o.Results) {
          //        if (r.SubInventoryID === stack[i].InventoryID) {
          //          Object.assign(o, stack[i].data);
          //          break;
          //        }
          //      }
          //     } else {
          //       if (stack[i].data.InventoryID === o.InventoryID) {
          //         Object.assign(o, stack[i].data);
          //       }
          //     }
          //   }
          // }
          // _self.selectedInventory = [];
          // _self.inventoryList.deselectAll();
        });*/
      }
    });
  }
  showMenuPopup(event) {
    this.menuPopup.show(event);
  }
  hideMenuPopup(event) {
    this.menuPopup.hide(event);
  }

  checkAll() {
    const _self = this;
    // picked check
  }
  getAuditReport(e) {
    const url = this.excRest.computeUrl('AuditR_Report', {AuditID: this.Data.AuditID});
    window.open(url, '_blank');
    this.hideMenuPopup(e);
  }
  getInventoryReport(e) {
    const _self = this;
    const url = this.excRest.computeUrl('AuditInventoryR_Export', {AuditID: _self.Data.AuditID, cult: _self.translateService.currentLang});
    window.open(url, '_blank');
    _self.hideMenuPopup(e);
  }
  closeReviewAPI(ratingSelected?: string, Comment?: string) {
    const _self = this;
    _self.menuPopup.hide();
    const url = _self.excRest.computeUrl('ReviewU_Finish', {AuditID: _self.Data.AuditID });
    _self.excRest.post(url, {ReviewRating: ratingSelected, ReviewUPT: null, Comment: Comment}, {}).subscribe(ret => {
      if (ret) {
        _self.tabinstance.Config.ReloadParent();
        _self.tabinstance.Close();
      }
    });
  }
  setFollowupDate() {
    const _self = this;
    _self.menuPopup.hide();
    ExcCoreModule.showModal(ModalFollowupDateEditComponent, null, 's', {FollowupDate: _self.data.Header['AuditFollowupDate']}, false, null).subscribe( ret => {
      if (ret && ret.proceed === true) {
        const url = _self.excRest.computeUrl('AuditU_FollowupDate', {AuditID: _self.data.Header['AuditID']});
        _self.excRest.post(url, {FollowupDate: ret.FollowupDate}, {}).subscribe(resp => {
          if (resp && resp.success === true) {
            Object.assign(_self.data.Header, resp.data[0]);
          }

        });
      }
    });
  }
  getAvatarClass(data) {
    return data.AuditType === 16
      ? data.AuditIsPicked ? 'fa-mobile th-warning' : 'fa-mobile th-secondary'
      : data.AuditIsPicked ? 'fa-user-secret th-warning' : 'fa-user-secret th-secondary';
  }
  closeReview() {
    const _self = this;
    _self.menuPopup.hide();
    const url = _self.excRest.computeUrl('ReviewBalanceR_Summary', {AuditID: this.Data['AuditID']});
    _self.excRest.get(url, {}).subscribe(balance => {
      ExcCoreModule.showModal(ModalReviewFinsihComponent, null, 'xxl', {Balance: balance.Balance, AutoScoring: (balance.AutoScoring || null)}, false, null).subscribe( ret => {
        if (ret && ret.proceed === true) {
          _self.closeReviewAPI(ret.ReviewRating , ret.Comment);
        }
      });
    });
  }
  pickedCheck() {
    if (!this.canCreatePickedCheck()) {
      return;
    }

    const preselected = {mode: 'ID', items: []};
    const _self = this;

    for (const x of this.selectedInventory) {
      preselected.items.push(x['InventoryID']);
    }

    this.aas.Create(this.data.Header, this.data.Auditors, preselected).subscribe(ret => {
      if (ret.Data.AuditFollowup && ret.Data.AuditFollowup === true) {
        _self.tabinstance.Config.ReloadParent();
        _self.tabinstance.Close();
      }
    });
  }
  editReviewGroup() {
    this.excRas.EditGroup(this.data.GroupAudits).subscribe(r => {
      if (r === true) {
        this.initialLoad();
      }
    });
  }

  formatAuditorText(auditorText: string | null | undefined): string {
    if (!auditorText) return '';
    return auditorText.replace(/;/g, '\n');
  }

  formatAuditorComment(auditorText: string | null | undefined): string {
    if (!auditorText) return '';
    return auditorText.replace(/(.{50})(?=.)/g, '$1\n');
  }
  partialLoad() {
    const _self = this;
    const url = _self.excRest.computeUrl('AuditR_Summary', {AuditID: this.Data.AuditID});
    _self.excRest.get(url, {}).subscribe(ret => {
      if (ret) {
        console.log(ret);
        _self.data['Header'] = ret.data['Header'];
        _self.data['Protocol'] = ret.data['Protocol'];
      }
    });
  }

  openSelectedStock(data: any) {
    let _self = this;
    this.backcheckVinValue = data.vehicleVIN;
    new ExcTab( this.data.Dealer[0].DealerName + ' - ' + data['AuditID'], AuditReviewComponent, data, data['AuditID'] + '-Bestand' ,
      {Unique: true, ReloadParent: function () { _self.partialLoad(); },
      }, true).Open();
    this.hideMenuPopup(data);
  }
  canCreatePickedCheck(): boolean {
    return this.selectedInventory.length > 0
      && this.Data.ReviewDone === false
      && this.Data.ReviewStarted === true
      && this.excSec.isFeatured('CLI_ADT_C');
  }

  openAudit() {
    const _self = this;
    new ExcTab(this.data.Dealer[0].DealerName + ' - ' + this.data.Header.AuditID, AuditDetailsComponent, this.data.Header, this.data.Header.AuditID, {
      Unique: true, ReloadParent: function () {
        _self.initialLoad();
      }
    }, true).Open();
  }

  editWhitBlackList(addToWhiteList = false, addToBlackList = false) {
    if (!this.excDss.MandantConfig.confDealerInventoryWhiteBlack) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }

    ExcCoreModule.showModal(
      ModalDealerBlackWhiteListComponent
      , null
      , 'xxl'
      , {
        dealer: this.data.Dealer,
        addToWhiteList: addToWhiteList ? this.selectedInventory : [],
        addToBlackList: addToBlackList ? this.selectedInventory : [],
        selectedTab: addToBlackList ? 1 : 0
      }
      , true
    ).subscribe( r => {
      if (r && r.proceed) {
        this.excRest.post(
          this.excRest.computeUrl(
            'DealerWhiteBlackListCU'
            , {})
          , {
            dealerList: r.dealerListJSON,
            whiteList: r.whiteListJSON,
            blackList: r.blackListJSON
          },
          {}
        ).subscribe(ret => {
          if (ret && ret.WhiteBlackList) {
            for (const retElement of ret.WhiteBlackList) {
              const dealerElement = this.data.Dealer.find((dealerElementFind: any) => dealerElementFind.DealerID === retElement.dlrIWB_MdtHdlr_Id);

              if (dealerElement) {
                dealerElement.dlrIWBWhiteList = retElement.dlrIWBWhiteList;
                dealerElement.dlrIWBBlackList = retElement.dlrIWBBlackList;
              }
            }
            this.reloadInventory();
          }
        });
      }
    });
  }
}
